import store from '../store';

export default function filterProfessions() {
    const allPopulations = store.state.populationEditor.populations;
    const allProfessions = store.state.populationEditor.professions;

    if (!allPopulations.length) {
        return allProfessions;
    }

    const fieldId = store.state.populationEditor.fieldId;
    const profession = store.state.populationEditor.profession;
    const currentProfession = allProfessions.find(o => o.id === profession);

    let currentPopulations = [];
    let profs = [];

    // Create array of this field's current populations.
    // Use this array to exclude populations from the selector, so that they can't be
    // used more than once.

    allPopulations.forEach(population => {
        if (population.field_id === fieldId) {
            currentPopulations.push(population.profession.id);
        }
    });

    // Create array of selectable professions.
    // Add this population's profession to the selectable professions.
    if (currentProfession) {
        profs.push(currentProfession);
    }

    allProfessions.forEach(pro => {
        // If profession is not in array of populations, add it to the selectable professions.
        if (!currentPopulations.includes(pro.id)) {
            if (pro.id !== 0) {
                profs.push(pro);
            }
        }
    });

    return profs;
}
